module.exports = __webpack_public_path__ + "img/logo-collins.c6c8ab34.webp";